import { render, staticRenderFns } from "./InfraTable.vue?vue&type=template&id=a98062c8&"
import script from "./InfraTable.vue?vue&type=script&lang=js&"
export * from "./InfraTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports